module.exports = __webpack_public_path__ + "static/media/2.50dff8b9.jpg";